<script setup>
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/16/solid';
import { onKeyUp } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import TextInput from './TextInput.vue';

const { t } = useI18n();

const input = ref(null);
const inputType = ref('password');
const isCapsLockActive = ref(false);
const isNumLockActive = ref(false);

const warning = computed(() => {
    if (isCapsLockActive.value) {
        return t('input.caps_lock_active');
    }

    if (isNumLockActive.value) {
        return t('input.num_lock_active');
    }

    return null;
});

const togglePassword = () => {
    inputType.value = inputType.value === 'password' ? 'text' : 'password';
};

onKeyUp(
    true,
    (e) => {
        isCapsLockActive.value = e.getModifierState('CapsLock');
        isNumLockActive.value = e.getModifierState('NumLock');
    },
    { target: input },
);

defineExpose({ focus: () => input.value?.focus() });
</script>

<template>
    <TextInput ref="input" :type="inputType" :warning="warning">
        <template #extra>
            <slot name="extra" />
        </template>
        <template #rightIcon>
            <EyeIcon
                v-if="inputType === 'password'"
                class="col-start-1 row-start-1 size-5 cursor-pointer self-center justify-self-end text-neutral-400"
                aria-hidden="true"
                @click="togglePassword"
            />
            <EyeSlashIcon
                v-else
                class="col-start-1 row-start-1 size-5 cursor-pointer self-center justify-self-end text-neutral-400"
                aria-hidden="true"
                @click="togglePassword"
            />
        </template>
    </TextInput>
</template>
